var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconGreyLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-date-1515275",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9588",
    "data-name": "Path 9588",
    d: "M30,50H46a4,4,0,0,0,4-4V30a4,4,0,0,0-4-4H30a4,4,0,0,0-4,4V46A4,4,0,0,0,30,50Zm16-2H30a2,2,0,0,1-2-2V34H48V46A2,2,0,0,1,46,48ZM30,28H46a2,2,0,0,1,2,2v2H28V30A2,2,0,0,1,30,28Z",
    transform: "translate(-26 -26)",
    fill: "#929292",
    stroke: "#f9f9f9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 14)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 17)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9 14)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9 17)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(13 14)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(13 17)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 14)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9 11)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(13 11)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 11)",
    fill: "#929292"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconGreyLight);
export default __webpack_public_path__ + "static/media/calendar-icon-grey-light.825547fd24acbee0242cb750ebdd5590.svg";
export { ForwardRef as ReactComponent };